import React, {useState, useEffect} from "react";
import { Modal, Form, InputNumber, Divider, Button, Row, Col } from 'antd';
import { useSelector, useDispatch } from 'react-redux';   
import { createTripExpense, getTripExpenseDetails ,resetTripExpense,updateTripExpense } from "../../../actions/trip-expense.actions";
import { getExpenseConfigByOperatorCode } from "../../../actions/expense-config.actions";
import { tripExpenseDetailsSelector } from "../../../selector/trip-expense.selector";
import { expenseConfigSelector, expenseTypesSelector } from "../../../selector/expense-config.selector";
import { isValid } from "../../../utils/utilities";


export const TripExpenseComponent = (props) => {
  const [form] = Form.useForm();
  const [total, setTotal] = useState(0);
  const dispatch = useDispatch();
  const [isModalOpen, setIsModalOpen] = useState(false);

  const tripExpense = useSelector(tripExpenseDetailsSelector);
  const expenseConfig = useSelector(expenseConfigSelector);
  const expenseTypes = useSelector(expenseTypesSelector);

  // Map expense type keys to form field names
  const getFormFieldName = (expenseKey) => {
    const fieldMap = {
      'bata': 'bata',
      'toll': 'toll',
      'pooja': 'pooja',
      'bus_expenses': 'bus_expense',
      'parking': 'parking_expense',
      'driver': 'driver_expense',
      'attender': 'attender_expense',
      'grease_and_air': 'grease_and_air_expense',
      'misc': 'misc'
    };
    return fieldMap[expenseKey] || expenseKey;
  };

  
  // Fetch expense config if not present
  useEffect(() => {
    if ((!expenseConfig || !expenseTypes) && global.operatorCode) {
      dispatch(getExpenseConfigByOperatorCode(global.operatorCode));
    }
  }, [expenseConfig, expenseTypes, dispatch]);

  useEffect(() => {
    if(isModalOpen){
      // Fetch expense config if not present before loading trip expense details
      if ((!expenseConfig || !expenseTypes) && global.operatorCode) {
        dispatch(getExpenseConfigByOperatorCode(global.operatorCode));
      }
      dispatch(getTripExpenseDetails(props.tripId));
    }
  }, [props.tripId, isModalOpen, dispatch, expenseConfig, expenseTypes]);


  useEffect(() => {
    if(tripExpense && expenseTypes && expenseConfig){
      let totalInitial = 0;
      const formValues = {};
      
      // Set form values dynamically based on expense types
      Object.keys(expenseTypes).forEach(expenseKey => {
        if(expenseConfig[expenseKey] === 1) {
          const fieldName = getFormFieldName(expenseKey);
          const value = tripExpense[fieldName];
          if(value !== undefined) {
            formValues[fieldName] = value;
            if(isValid(value)){
              totalInitial += value;
            }
          }
        }
      });
      
      form.setFieldsValue(formValues);
      setTotal(totalInitial);
    }

  }, [tripExpense, expenseTypes, expenseConfig, form]);

  


  const showModal = () => {
    setIsModalOpen(true);
  };

  const handleCancel = () => {
    dispatch(resetTripExpense());
    form.resetFields();
    setIsModalOpen(false);
  };

  const handleUpdate = () => {
    form.validateFields()
      .then(values => {
        console.log('Success:', values);
        setIsModalOpen(false);
        form.resetFields();
        if(tripExpense&&tripExpense.id){
          dispatch(updateTripExpense(props.tripId,values));
        }else{
          dispatch(createTripExpense(props.tripId,values));
        }
      })
      .catch(info => {
        console.log('Validate Failed:', info);
      });


  };

  // Calculate total whenever form values change
  const handleValuesChange = (changedValues, allValues) => {
    const sum = Object.values(allValues).reduce((acc, val) => acc + (val || 0), 0);
    setTotal(sum);
  };

  // Render expense form fields dynamically based on expense config
  const renderExpenseFields = () => {
    if (!expenseTypes || !expenseConfig) {
      return null;
    }

    const fields = [];
    const expenseTypeKeys = Object.keys(expenseTypes);
    
    // Filter expense types that should be shown (expenseConfig value is 1)
    const visibleExpenseTypes = expenseTypeKeys.filter(key => {
      return expenseConfig[key] === 1;
    });

    // Sort by order property (if order is not present, treat as 0)
    const sortedExpenseTypes = visibleExpenseTypes.sort((a, b) => {
      const orderA = expenseTypes[a]?.order || 0;
      const orderB = expenseTypes[b]?.order || 0;
      return orderA - orderB;
    });

    // Group fields into rows of 2
    for (let i = 0; i < sortedExpenseTypes.length; i += 2) {
      const rowFields = sortedExpenseTypes.slice(i, i + 2);
      fields.push(
        <Row gutter={[16, 16]} key={`row-${i}`}>
          {rowFields.map(expenseKey => {
            const expenseType = expenseTypes[expenseKey];
            const fieldName = getFormFieldName(expenseKey);
            return (
              <Col span={12} key={expenseKey}>
                <Form.Item name={fieldName} label={expenseType.label}>
                  <InputNumber
                    formatter={value => `₹ ${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')}
                    parser={value => value.replace(/₹\s?|(,*)/g, '')}
                    style={{ width: '100px' }}
                    min={0}
                  />
                </Form.Item>
              </Col>
            );
          })}
        </Row>
      );
    }

    return fields;
  };

  return (
    <>
      <style>
        {`
          .trip-expense-modal .ant-form-item-label > label {
            white-space: normal !important;
            word-wrap: break-word !important;
            word-break: break-word !important;
            line-height: 1.4 !important;
            height: auto !important;
          }
        `}
      </style>
      <Button type="primary" 
      className="bordered-btn send-driver-details-btn"
      onClick={showModal}>
        Trip Expense
      </Button>
      <Modal
        title="Trip Expense"
        visible={isModalOpen}
        onCancel={handleCancel}
        footer={null}
        className="trip-expense-modal"
      >
        <Form
          form={form}
          layout="horizontal"
          labelCol={{ span: 12 }}
          wrapperCol={{ span: 12 }}
          onValuesChange={handleValuesChange}
        >
          {renderExpenseFields()}

          <Divider style={{ borderColor: 'black', borderWidth: 2 }} />
          
          <Form.Item label="" style={{ fontWeight: 'bold',justifyContent:'center',textAlign:'center' }}>
            <span>Total: ₹ {total.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',')}</span>
          </Form.Item>
        </Form>
        <div style={{ display: 'flex', justifyContent: 'space-around' }}>
            <Button key="cancel" onClick={handleCancel}
            className="exit-btn"
            >
              Exit
            </Button>
              <Button key="update" type="primary" onClick={handleUpdate}>
              {tripExpense&&tripExpense.id?"Update":"Create"}
            </Button>
          </div>
      </Modal>
    </>
  );
};